import { parseISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export default function PostDate({ dateString }: { dateString: string }) {
  if (!dateString) return null

  const date = parseISO(dateString)
  // Format using a fixed time zone (e.g., UTC) for consistency
  const formatted = formatInTimeZone(date, 'UTC', 'LLLL d, yyyy')

  return <time dateTime={dateString}>{formatted}</time>
}